<template lang="pug">
    div
        .title
            slot(name='title')
        form(action='javascript://', v-if='puzzleParams')
            form-tabs(
                v-if="homeworkHasAtLeastTwoDates || templateHasDays",
                :homework-tab-after-game-edit="homeworkTabAfterGameEdit"
                elements-type="homework"
                :tabs-number="tabsNumber",
                :same-settings-are-active="false",
                :disable-name-change="true"
                :custom-tab-names="customTabNames"
                @setCurrentTab="num => currentHomeworkTab = num"
            )
            .form-container(v-if='!homework || homework.editable === undefined || (homework && (homework.editable || usersIds))')
                .row
                    .form-container__column
                        label.form-container__label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_size') }}
                        .form-container__select
                            cs-multiselect(
                                :multiple='false',
                                :options='difficulties',
                                :show-labels='false',
                                :allow-empty='false',
                                v-model="puzzleParams.difficult",
                                placeholder="",
                                label='name',
                            )
                .row
                    .form-container__column
                        label.form-container__label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_image') }}
                        .form-container__select
                            div
                                cs-image-input(
                                    type="battle",
                                    :accept="['image/png', 'image/jpeg']",
                                    @input='imageHandler',
                                    @showSizeError='showSizeError',
                                    @showFileError='showFileError',
                                    @showTypeError='showTypeError',
                                    :image='puzzleParams.image',
                                    :load-text="$i18n.t('trainer.trainer_gameFormSetting_uploadImage')",
                                    :remove-text="$i18n.t('trainer.trainer_gameFormSetting_removeImage')",
                                    :help-text="$i18n.t('common.common_imageInput_sizeHelpText')",
                                    :crop='false',
                                    :error="showImageWarning ? imageWarningText : ''"
                                )
                            .image-selector__text
                                | {{ $i18n.t('games.games_or') }}
                                |
                                a.image-input__link(@click='openModal')
                                    | {{ $i18n.t('games.games_gameSettings_selectFromLoaded') }}
                                cs-modal(v-if='isModalOpened', @close='closeModal', :puzzle-images="true")
                                    div(slot='header') {{ $i18n.t('games.games_gallery') }}
                                    .image-slider
                                        .image-slider__arrow.image-slider__arrow_left(
                                            @click="prevImagesSlideHandler",
                                            :class="{'image-slider__arrow_disabled': currentImagesSlideIndex === 0}"
                                        )
                                            svg-icon(size="big", name="angle-left")
                                        .images-wrapper
                                            .image-container(
                                                v-for='image in currentImages',
                                                :class="{'image-container_selected': selectedImage === image}"
                                            )
                                                img(
                                                    :src='image',
                                                    @dblclick='selectImageFromGallery($event)',
                                                    @click="selectedImage = image"
                                                )
                                        .image-slider__arrow.image-slider__arrow_right(
                                            @click="nextImagesSlideHandler",
                                            :class="{'image-slider__arrow_disabled': currentImagesSlideIndex === amountOfImagesSlides - 1}"
                                        )
                                            svg-icon(size="big", name="angle-right")
                                    .image-slider
                                        .image-slider__circle(
                                            v-for="circleIndex in amountOfImagesSlides",
                                            :class="{'image-slider__circle_active': circleIndex - 1 === currentImagesSlideIndex}"
                                        )
                .row
                    .form-container__column
                        label.form-container__label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_typeOfExamples') }}
                        .form-container__select
                            cs-multiselect(
                                :multiple='false',
                                :options='gamesForGenerateExamples',
                                :show-labels='false',
                                :allow-empty='false',
                                :placeholder="$i18n.t('course.course_form_chooseGames')",
                                :disabled='gamesForGenerateExamples.length === 0 || puzzleParams.games.length > 0',
                                v-model="selectedGame",
                                label='label',
                                @select='gameHandler'
                            )
                            span.help(v-if='gamesForGenerateExamples.length === 0')
                                | {{ $i18n.t('homework.homework_create_noGameAccess') }}
                .row
                    .form-container__column.form-container__column_centered
                        .form-container__select.form-container__select_fixed-width
                            games-list(
                                :games='puzzleParams.games',
                                :in-trainer='true',
                                @editGame='editSelectedGame',
                                @remove='removeSelectedGame'
                            )
            divider
            .form-container.form-container_text-centered
                slot(name='parameters', v-if="!($route.params && $route.params.source && $route.params.source === 'homework-template') && !templateHasDays && !homeworkHasAtLeastTwoDates ")
                .help-text
                    slot(name='help')
                template(v-if='!usersIds')
                    .form-container__footer-buttons
                        cs-button.cancel-button(color="blue", pattern="primary-outline", type='button', @click='cancel')
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                        template(v-if="gameMode && gameMode === 'free-game'")
                            cs-button.save-button(color="blue", type='button', :disabled="disableButton", @click='saveGame')
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                        template(v-else-if='isOlympiad')
                            cs-button.save-button(color="blue", type='button', :disabled="disableButton", @click='saveOlympiadStage')
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                        template(v-else-if='isBattle')
                            cs-button.save-button(color="blue", type='button', :disabled="disableButton", @click='saveBattleStage')
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                        template(v-else)
                            cs-button.save-button(color="blue", type='button', :disabled="disableButton", @click='saveHomework')
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
</template>

<script>
/*eslint-disable*/

    import _ from 'lodash';
    import { mapState } from 'vuex';
    import TrainerGames from '../../../config/trainer';
    import OlympiadGamesDefaultParameters from '../../olympiad/config/level';
    import BattleGamesDefaultParameters from '../../mental-battle/config/level';
    import ComparingTrainersParameters from '../../../utils/trainer/comparingTrainersParameters';
    import GradeApi from '../../../api/grade';
    import getBase64FromUrl from '../../../utils/getBase64FromUrl';

    import GamesList from '../GamesList.vue';
    import CsModal from '../../../elements/CsModal.vue';
    import FormTabs from '../shared/FormTabs';
    import { getInitParameters } from '../../../utils/trainer/getInitParameters';

    const MIN_IMAGE_WIDTH = 500;
    const MIN_IMAGE_HEIGHT = 500;

    export default {
        components: {
            GamesList,
            CsModal,
            FormTabs,
        },
        props: ['slug', 'courseType', 'id', 'usersIds', 'homeworkId', 'gameMode', 'levelAnswerDuration'],
        mixins: [ComparingTrainersParameters, getBase64FromUrl],
        data() {
            return {
                namesForDays: ['1', '2', '3', '4', '5', '6', '7', '8'],
                currentHomeworkTab: 1,
                homeworkTabAfterGameEdit: 1,
                puzzleParamsArray: [],
                images: [],
                isModalOpened: false,
                courseGames: null,
                puzzleParams: {
                    difficult: null,
                    image: null,
                    games: [],
                },
                difficulties: [
                    {
                        name: '3 x 3',
                        x: 3,
                        y: 3,
                    },
                    {
                        name: '3 x 4',
                        x: 3,
                        y: 4,
                    },
                    {
                        name: '4 x 5',
                        x: 4,
                        y: 5,
                    },
                ],
                possibleGames: [
                    'Anzan',
                    'Equation',
                    'InteractiveFlashCards',
                    'AdditionAndSubtraction',
                    'AdditionAndSubtractionWithTime',
                    'MultiplicationAndDivision',
                ],
                trainerGames: _.cloneDeep(TrainerGames),
                showImageWarning: false,
                imageWarningText: '',
                selectedGame: null,
                currentImagesSlideIndex: 0,
                amountOfImagesSlides: 0,
                selectedImage: null,
            };
        },
        mounted() {
            if (this.puzzleGamesParams?.length) {
                this.puzzleParamsArray = _.cloneDeep(this.puzzleGamesParams);
            }
            this.importImages(require.context('../../../../public/imgs/games/puzzle', true, /\.(jpg|png)$/));
            if (
                this.gamesParameters &&
                !Object.keys(this.gamesParameters).includes('Puzzle') &&
                !this.isOlympiad &&
                !this.isBattle
            ) {
                this.puzzleParams = null;
                return;
            }
            if (this.homework && this.homework.grades) {
                this.homework.grades.forEach(grade => {
                    grade.course.games.forEach(game => {
                        this.gamesForComparison.push(game);
                    });
                });
                this.setNeededSettingsOnMounted();
                if (this.id || parseInt(this.id) === 1) {
                    this.puzzleParams =
                        this.puzzleParamsArray.length > 1
                            ? this.puzzleParamsArray[0]
                            : this.homework.games[this.id].parameters.default;
                    if (this.puzzleParams.games[0]) {
                        this.selectedGame = this.puzzleParams.games[0]
                    }
                    return;
                }
            } else if (
                this.$route.params?.source === 'homework-template'
            ) {
                if (this.homework?.courses) {
                    this.homework.courses.forEach(course => {
                        course.games.forEach(game => {
                            this.gamesForComparison.push(game);
                        });
                    });
                    this.setNeededSettingsOnMounted();
                    if (this.id || parseInt(this.id) === 0) {
                        this.puzzleParams =
                            this.puzzleParamsArray.length > 1
                                ? this.puzzleParamsArray[0]
                                : this.homework.games[this.id].parameters.default;
                        return;
                    }
                }
            } else if (this.isOlympiad && this.gamesParameters) {
                this.puzzleParams = _.cloneDeep(
                    this.levels[+this.$route.params.index].stages[+this.$route.params.stageId].games[this.id].parameters
                        .default
                );
                if (this.levels[+this.$route.params.index]) {
                    this.courseGames = this.levels[+this.$route.params.index].course
                        ? this.levels[+this.$route.params.index].course.games
                        : OlympiadGamesDefaultParameters.games;
                    this.refreshPossibleGames();
                }
                return;
            } else if (this.isBattle && this.gamesParameters) {
                this.puzzleParams = _.cloneDeep(
                    this.battleLevels[+this.$route.params.index].stages[+this.$route.params.stageId].games[this.id]
                        .parameters.default
                );
                if (this.battleLevels[+this.$route.params.index]) {
                    this.courseGames = this.battleLevels[+this.$route.params.index].course
                        ? this.battleLevels[+this.$route.params.index].course.games
                        : BattleGamesDefaultParameters.games;
                    this.refreshPossibleGames();
                }
                return;
            } else if (!this.homework && this.user.type === 'student') {
                this.getCourseGames();
            }

            if (this.puzzleGame) {
                if (this.homework && this.homework.courses) {
                    this.homework.courses.forEach(course => {
                        this.gamesForComparison.push(...course.games);
                    });
                }
                if (!this.courseGames?.length) {
                    this.courseGames = _.cloneDeep(this.getGamesAfterComparison());
                }
                this.setPuzzleParams(!!this.puzzleGamesParams?.length);
            } else {
                this.puzzleParams.difficult = this.difficulties[0];
            }
            this.selectedGame = this.puzzleParams.games[0];
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                homeworkCopy: state => state.trainer.homeworkCopy,
                puzzleGame: state => state.games.puzzle,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user,
                levels: state => {
                    return state.olympiad.intermediateStage && state.olympiad.intermediateStage.levels;
                },
                battleLevels: state => {
                    return state.battle.intermediateBattleStage && state.battle.intermediateBattleStage.levels;
                },
                puzzleGamesParams: state => state.trainer.puzzleGamesParams,
            }),
            currentAmountOfDays() {
                return this.homework?.dates ? this.homework?.dates.length : this.homework?.chosenDaysAmount;
            },
            customTabNames() {
                if (this.homework && this.homework.dates?.length > 1) {
                    return this.homework.dates
                        .slice()
                        .reverse()
                        .map(date => {
                            let dateAsClassObject = new Date(date);
                            const [day, month] = [dateAsClassObject.getDate(), dateAsClassObject.getMonth() + 1];
                            const addLeadingZeros = number => {
                                return number < 10 ? '0' + number : '' + number;
                            };
                            return addLeadingZeros(day) + '.' + addLeadingZeros(month);
                        });
                }
                if (this.homework?.chosenDaysAmount > 1) {
                    return this.namesForDays;
                }
                return [];
            },
            gamesForGenerateExamples() {
                return _.filter(this.trainerGames.games, game => {
                    return this.possibleGames.indexOf(game.slug) !== -1;
                }).map(game => {
                    if (game.label) {
                        game.label = this.$i18n.t(game.label);
                    } else {
                        game.label = game.name;
                    }
                    return game;
                });
            },
            templateHasDays() {
                return this.homework?.chosenDaysAmount > 1 || this.homework?.dates?.length > 1;
            },
            homeworkHasAtLeastTwoDates() {
                return this.homework?.dates?.length > 1;
            },
            tabsNumber() {
                return !this.homeworkHasAtLeastTwoDates ? this.homework.chosenDaysAmount : this.homework.dates.length;
            },
            disableButton() {
                if (this.puzzleParamsArray.length > 1) {
                    return this.puzzleParamsArray.some(param => !param.games.length > 0 || !param.image);
                }
                return !(this.puzzleParams.games.length > 0 && this.puzzleParams.image);
            },
            isOlympiad() {
                return !this.gameMode && !this.homework && this.levels;
            },
            isBattle() {
                return !this.gameMode && !this.homework && this.battleLevels;
            },
            currentImages() {
                let formattedImagesArray = _.chunk(this.images, 6);
                this.amountOfImagesSlides = formattedImagesArray.length;
                return formattedImagesArray[this.currentImagesSlideIndex];
            },
        },
        watch: {
            currentHomeworkTab(value) {
                if (value) {
                    this.puzzleParams = this.puzzleParamsArray[value - 1];
                    this.selectedGame = this.puzzleParams.games[0];
                }
            },
        },
        methods: {
            getCourseGames() {
                return new Promise((resolve, reject) => {
                    GradeApi.list()
                        .then(response => {
                            if (response.data) {
                                response.data.forEach(grade => {
                                    grade.course.games.forEach(game => {
                                        this.gamesForComparison.push(game);
                                    });
                                });
                                this.courseGames = _.cloneDeep(this.getGamesAfterComparison());
                                this.refreshPossibleGames();
                            }
                            resolve();
                        })
                        .catch(err => {
                            if (err.data) {
                                this.$toasted.error(err.data.message);
                                this.$router.push({ name: 'dashboard' });
                            }
                            err = err.response && err.response.data ? err.response.data : err;
                            if (err && (err.status_code === 403 || err.status_code === 404)) {
                                this.$router.push({ name: 'dashboard' });
                            }
                            reject();
                        });
                });
            },
            setNeededSettingsOnMounted() {
                if (_.isArray(this.homework.games[this.id].parameters?.default)) {
                    this.puzzleParamsArray = this.homework.games[this.id].parameters.default;
                }
                this.$store.dispatch('setPuzzleGamesParamsArray', _.cloneDeep(this.puzzleParamsArray));
                this.setPuzzleParams(!!this.puzzleGamesParams?.length);
                this.courseGames = _.cloneDeep(this.getGamesAfterComparison());
                this.refreshPossibleGames();
                if (this.puzzleParamsArray.length !== this.currentAmountOfDays) {
                    this.setNeededLengthForParamsArray();
                }
            },
            setPuzzleParams(puzzleGamesParamsAreExistent) {
                if (this.currentAmountOfDays > 1) {
                    if (puzzleGamesParamsAreExistent) {
                        this.puzzleParamsArray = _.cloneDeep(this.puzzleGamesParams);
                        if (this.puzzleGame) {
                            this.homeworkTabAfterGameEdit = this.puzzleGame.arrayPosition + 1;
                            this.puzzleParamsArray[this.puzzleGame.arrayPosition] = this.puzzleGame;
                        }
                        this.puzzleParams = _.cloneDeep(this.puzzleParamsArray[0]);
                    }
                } else {
                    if (puzzleGamesParamsAreExistent) {
                        this.puzzleParams = _.cloneDeep(this.puzzleParamsArray[0]);
                        this.$store.dispatch('setPuzzleGamesParamsArray', null);
                        return;
                    }
                    this.puzzleParams = this.puzzleGame
                        ? _.cloneDeep(this.puzzleGame)
                        : this.homework.games[0].parameters.default;
                }
            },
            setNeededLengthForParamsArray() {
                while (this.puzzleParamsArray.length < this.currentAmountOfDays) {
                    this.puzzleParamsArray[0] = _.isArray(this.homework.games[this.id].parameters.default)
                        ? this.homework.games[this.id].parameters.default[0]
                        : this.homework.games[this.id].parameters.default;
                    this.puzzleParams = this.puzzleParamsArray[0];
                    this.pushDefaultSettingIntoParamsArray(this.puzzleParamsArray);
                    this.pushDefaultSettingIntoParamsArray(this.puzzleGamesParams);
                }
                while (this.puzzleParamsArray.length > this.currentAmountOfDays) {
                    this.cropParamsArrayToNeededLength();
                }
                this.$store.dispatch('setPuzzleGamesParamsArray', _.cloneDeep(this.puzzleParamsArray));
            },
            pushDefaultSettingIntoParamsArray(array) {
                array.push(
                    _.cloneDeep(
                        getInitParameters({
                            slug: this.slug,
                            parameters: {
                                default: _.cloneDeep(this.gamesParameters[this.slug]),
                            },
                        })
                    )
                );
            },
            cropParamsArrayToNeededLength() {
                this.puzzleParams = this.puzzleParamsArray[0];
                this.puzzleParamsArray.pop();
                if (this.puzzleParamsArray.length === 1) {
                    this.homework.games[this.id].parameters.default = this.puzzleParamsArray[0];
                }
            },
            refreshPossibleGames() {
                if (this.courseGames.length) {
                    let names = [];
                    this.courseGames.forEach(game => {
                        if (this.possibleGames.includes(game.slug)) {
                            names.push(game.slug);
                        }
                    });
                    this.possibleGames = names;
                }
            },
            importImages(root) {
                this.images = root.keys().map(key => '/imgs/games/puzzle' + key.substr(1));
            },
            selectImageFromGallery(event) {
                let canvas = document.createElement('CANVAS');
                let ctx = canvas.getContext('2d');
                let dataURL;
                canvas.height = event.target.naturalHeight;
                canvas.width = event.target.naturalWidth;
                ctx.drawImage(event.target, 0, 0);
                dataURL = canvas.toDataURL('image/jpg');
                this.imageHandler(dataURL);
                this.closeModal();
            },
            openModal() {
                this.isModalOpened = !this.isModalOpened;
            },
            closeModal() {
                this.isModalOpened = !this.isModalOpened;
            },
            imageHandler(image) {
                this.puzzleParams.image = image;
                if (this.puzzleParams.imageSrc) {
                    this.puzzleParams.imageSrc = '';
                }
                this.puzzleParams.isImageChanged = true;
                this.getImageDimensions(image).then(dimensions => {
                    if (dimensions.width < MIN_IMAGE_WIDTH || dimensions.height < MIN_IMAGE_HEIGHT) {
                        this.imageWarningText = this.$i18n.t('trainer.trainer_gameFormSetting_imageSizeWarning');
                        this.showImageWarning = true;
                        this.puzzleParams.image = null;
                    } else {
                        this.showImageWarning = false;
                        this.imageWarningText = '';
                    }
                });
            },
            showSizeError() {
                this.imageWarningText = this.$i18n.t('trainer.trainer_gameFormSetting_imageWeightWarning');
                this.showImageWarning = true;
            },
            showTypeError() {
                this.imageWarningText = this.$i18n.t('trainer.trainer_gameFormSetting_imageTypeWarning');
                this.showImageWarning = true;
            },
            showFileError() {
                this.imageWarningText = this.$i18n.t('trainer.trainer_gameFormSetting_imageFileWarning');
                this.showImageWarning = true;
            },
            gameHandler(game) {
                this.puzzleParams.games.push(_.cloneDeep(game));
                this.selectedGame = game;
                if (this.homework) {
                    this.homework.games[this.id].parameters.default = _.cloneDeep(this.puzzleParams);
                }
            },
            editSelectedGame(index) {
                let game = this.puzzleParams.games[index];
                if (!this.isOlympiad && !this.isBattle) {
                    if (this.courseGames && this.gameMode !== 'free-game') {
                        let gamesParameters = _.cloneDeep(this.gamesParameters);
                        let slug = game.slug;
                        this.$store.dispatch('setPuzzleGamesParamsArray', null);
                        if (this.currentAmountOfDays > 1) {
                            this.$set(this.puzzleParams, 'arrayPosition', this.currentHomeworkTab - 1);
                            gamesParameters[slug] = game.parameters.default;
                            this.$store.dispatch('setPuzzleGamesParamsArray', _.cloneDeep(this.puzzleParamsArray));
                        } else {
                            gamesParameters[slug] = game.parameters.default;
                            this.$store.dispatch('setGamesParameters', _.cloneDeep(gamesParameters));
                        }
                        this.$store.dispatch('setGamesParameters', _.cloneDeep(gamesParameters));
                    }
                    this.$store.dispatch('setPuzzleGame', this.puzzleParams);
                    let params = {
                        id: index,
                        gameId: this.id,
                        gameMode: 'generator-settings',
                    };
                    if (
                        this.$route.params?.source === 'homework-template'
                    ) {
                        Object.assign(params, { source: this.$route.params.source });
                    }
                    this.$router.push({
                        name: 'create:game',
                        params: params,
                        query: { slug: game.slug, generatorSettings: true },
                    });
                } else if (this.isBattle) {
                    let gamesParameters = {};
                    let slug = game.slug;
                    let gameForSetGamesParameters = _.find(this.courseGames, { slug });
                    gamesParameters[slug] = gameForSetGamesParameters.parameters.default;
                    this.$store.dispatch('setGamesParameters', gamesParameters);
                    this.assignBattleStageValues();
                    let routeParams = {
                        battleId: this.$route.params.battleId,
                        index: this.$route.params.index,
                        stageId: this.$route.params.stageId,
                        id: this.$route.params.id,
                        generatorSettings: 'generator-settings',
                        generatorGameIndex: index,
                    };
                    let routeName = this.$route.name.includes('training')
                        ? 'battle-training-stage-game:edit'
                        : 'battle-stage-game:edit';
                    this.$router.push({ name: routeName, params: routeParams });
                } else {
                    let gamesParameters = {};
                    let slug = game.slug;
                    let gameForSetGamesParameters = _.find(this.courseGames, { slug });
                    gamesParameters[slug] = gameForSetGamesParameters.parameters.default;
                    this.$store.dispatch('setGamesParameters', gamesParameters);
                    this.assignOlympiadStageValues();
                    let routeParams = {
                        olympiadId: this.$route.params.olympiadId,
                        index: this.$route.params.index,
                        stageId: this.$route.params.stageId,
                        id: this.$route.params.id,
                        generatorSettings: 'generator-settings',
                        generatorGameIndex: index,
                    };
                    this.$router.push({ name: 'stage-game:edit', params: routeParams });
                }
            },
            removeSelectedGame(index) {
                this.puzzleParams.games.splice(index, 1);
                this.selectedGame = null;
                if (this.homework) {
                    this.homework.games[this.id].parameters.default = _.cloneDeep(this.puzzleParams);
                }
            },
            cancel() {
                this.$store.dispatch('setPuzzleGame', null);
                this.$store.dispatch('setGame', null);
                if (this.homework) {
                    this.$store.dispatch('setHomework', _.cloneDeep(this.homeworkCopy));
                    this.$store.dispatch('setHomeworkCopy', null);
                    this.$router.back();
                    return;
                }
                if (this.isOlympiad) {
                    let routeParams = {
                        olympiadId: this.$route.params.olympiadId,
                        index: this.$route.params.index,
                    };
                    this.$router.push({ name: 'olympiad-level:create', params: routeParams });
                    return;
                }
                if (this.isBattle) {
                    let routeParams = {
                        battleId: this.$route.params.battleId,
                        index: this.$route.params.index,
                    };
                    this.$router.push({ name: 'battle-level:create', params: routeParams });
                    return;
                }
                this.$router.push({ name: 'trainer:games' });
            },
            saveGame() {
                if (this.homework) {
                    this.puzzleParamsArray?.length > 1
                        ? (this.homework.games[this.id].parameters.default = _.cloneDeep(this.puzzleParamsArray))
                        : (this.homework.games[this.id].parameters.default = _.cloneDeep(this.puzzleParams));
                }
                this.$store.dispatch('setPuzzleGame', this.puzzleParams);
                this.$store.dispatch('setGame', this.puzzleParams.games[0].parameters.default);
                this.$store.dispatch('setParamsArray', [this.puzzleParams.games[0].parameters.default]);
                this.$router.push({
                    name: 'browse:game',
                    params: { type: 'Puzzle', courseType: 'mentalArithmetic' },
                });
            },
            saveHomework() {
                if (this.puzzleParamsArray.length === 1) {
                    this.homework.games[this.id].parameters.default = _.cloneDeep(this.puzzleParams);
                    this.puzzleParamsArray = [];
                } else if (this.puzzleParamsArray.length > 1) {
                    this.puzzleParamsArray.length > 1
                        ? (this.homework.games[this.id].parameters.default = _.cloneDeep(this.puzzleParamsArray))
                        : (this.homework.games[this.id].parameters.default = _.cloneDeep(this.puzzleParams));
                }
                if (
                    this.homework.games[this.id].sourceType &&
                    this.homework.games[this.id].sourceType === 'homeworkTemplate'
                ) {
                    const gameDefaultParameters = this.homework.games[this.id].parameters.default;
                    if (_.isArray(gameDefaultParameters)) {
                        this.homework.games[this.id].parameters.default.map(params => {
                            params.imageSrc = '';
                        });
                    } else {
                        this.homework.games[this.id].parameters.default.imageSrc = '';
                    }
                }
                this.$store.dispatch('setHomework', this.homework);
                this.$store.dispatch('setHomeworkCopy', null);
                this.$store.dispatch('setPuzzleGamesParamsArray', null);
                this.$router.back();
            },
            saveOlympiadStage() {
                this.assignOlympiadStageValues();
                let params = {
                    index: this.$route.params.index,
                    olympiadId: this.$route.params.olympiadId,
                };
                this.$router.push({ name: 'olympiad-level:create', params });
            },
            assignOlympiadStageValues() {
                if (this.levels) {
                    let stage = this.levels[+this.$route.params.index].stages[+this.$route.params.stageId];
                    stage = _.cloneDeep(stage);
                    stage.games[this.id].parameters.default = _.cloneDeep(this.puzzleParams);
                    stage.games[this.id].isEdited = true;
                    this.levels[+this.$route.params.index].stages[+this.$route.params.stageId] = stage;
                }
            },
            saveBattleStage() {
                this.assignBattleStageValues();
                let params = {
                    index: this.$route.params.index,
                    battleId: this.$route.params.battleId,
                };
                let routeName = this.$route.name.includes('training')
                    ? 'battle-training-level:create'
                    : 'battle-level:create';
                this.$router.replace({ name: routeName, params });
            },
            assignBattleStageValues() {
                if (this.battleLevels) {
                    let stage = this.battleLevels[+this.$route.params.index].stages[+this.$route.params.stageId];
                    stage = _.cloneDeep(stage);
                    stage.games[this.id].parameters.default = _.cloneDeep(this.puzzleParams);
                    stage.games[this.id].isEdited = true;
                    this.battleLevels[+this.$route.params.index].stages[+this.$route.params.stageId] = stage;
                }
            },
            getImageDimensions(base64Data) {
                return new Promise((resolve, reject) => {
                    let i = new Image();
                    i.onload = function() {
                        resolve({ width: i.width, height: i.height });
                    };
                    i.src = base64Data;
                });
            },
            prevImagesSlideHandler() {
                if (this.currentImagesSlideIndex !== 0) {
                    this.currentImagesSlideIndex -= 1;
                }
            },
            nextImagesSlideHandler() {
                if (this.currentImagesSlideIndex !== this.amountOfImagesSlides - 1) {
                    this.currentImagesSlideIndex += 1;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .title {
        display: flex;
        justify-content: center;
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }
    .row {
        margin: 0;
    }
    .form-container {
        width: 100%;
        max-width: 820px;
        margin: 0 auto;
    }
    .form-container_text-centered {
        text-align: center;
    }
    .form-container__column {
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        @media screen and (max-width: 767px) {
            flex-direction: column;
        }
    }
    .form-container__column_centered {
        justify-content: center;
    }
    .form-container__label {
        margin-right: 20px;
        width: 30%;
        text-align: right;
        @media screen and (max-width: 767px) {
            width: 100%;
            margin: 0 0 10px 0;
            text-align: left;
        }
    }
    .form-container__select {
        width: 100%;
        max-width: 300px;
        @media screen and (max-width: 767px) {
            max-width: none;
        }
    }
    .form-container__select_fixed-width {
        max-width: 518px;
    }
    .form-container__footer-buttons {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        @media screen and (max-width: 767px) {
            flex-direction: column;
        }
    }
    .cancel-button {
        width: 200px;
    }
    .save-button {
        width: 200px;
        margin-left: 20px;
        @media screen and (max-width: 767px) {
            margin: 20px 0 0 0;
        }
    }
    .help-text {
        color: #888888;
    }
    .image-input__link {
        cursor: pointer;
        margin-right: 20px;
        font-size: 16px;
        line-height: 19px;
        color: $hsl-color-blue-56;
        text-decoration: underline;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }
    .image-container {
        cursor: pointer;
        margin: 10px;
        background: #ffffff;
        border: 2px solid #e6e6f8;
        box-sizing: border-box;
        border-radius: 10px;
        padding: 5px;
        @media screen and (max-width: 767px) {
            margin: 8px;
        }
        @media screen and (max-width: 575px) {
            margin: 5px;
        }
        img {
            width: 120px;
            height: 120px;
            @media screen and (max-width: 575px) {
                width: 70px;
                height: 70px;
            }
        }
        &_selected {
            border-color: #2187ff;
        }
    }
    .images-wrapper {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        width: 462px;
        @media screen and (max-width: 575px) {
            width: 188px;
        }
    }
    .image-selector__text {
        margin-top: 20px;
    }
    .image-slider {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .image-slider__circle {
        width: 10px;
        height: 10px;
        background: #e6e6f8;
        margin: 5px;
        border-radius: 50%;
        &_active {
            background: #2187ff;
        }
    }
    .image-slider__arrow {
        color: #2187ff;
        &_disabled {
            pointer-events: none;
            color: $hsl-color-gray-53;
        }
    }
</style>
